const initialState = {
  allMentors: [],
};

const mentorReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_ALL_MENTORS":
      return {
        ...state,
        allMentors: payload,
      };
    default:
      return state;
  }
};

export default mentorReducer;
